import { render, staticRenderFns } from "./MedicineModAvb.vue?vue&type=template&id=e2f93734"
import script from "./MedicineModAvb.vue?vue&type=script&lang=js"
export * from "./MedicineModAvb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports